import SearchSimple from '../../../../components/SearchSimples/SearchSimple';
import React from 'react';
import AttendingUsersTableApp from './Functionality/AttendingUsersTableApp';
import UserCardDetails from './SubComponents/UserCardDetails';
import CreateVisitorModal from '../../Visitor/Modal/CreateVisitorModal';
import {MODELS} from "../../../../Apis/Models";

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const AttendingUsersTable = (props) => {

    const {
        setBodyForExport,
        setSearch,
        setSimpleSearch,
        setUsersSelected,
        usersSelected,
        showCreateNewVisitorModal,
        setShowCreateNewVisitorModal,
        modified,
        setModified,
        optionTable,
        results,
        setResults,
        searchElement,
        setSearchElement,
        userTypeIds
    } = props;


    const {
        t,
        pagination,
        rowsPerPage,
        getData,
        visitorSelected,
        setVisitorSelected,
        getChildrenNoInformation,
        elementRef
    } = AttendingUsersTableApp({
        optionTable,
        results,
        setResults,
        searchElement,
        setSearchElement,
        userTypeIds,
        setShowCreateNewVisitorModal
    });

    return (
        <>
            <SearchSimple
                id={"txt_search_users_types"}
                label={"search_by_name_email_or_phone"}
                setBodyForExport={setBodyForExport}
                setSearchResults={setResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                optionTable={optionTable}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                setSimpleSearch={setSimpleSearch}
                contractorId={null}
                supplierId={null}
                callApi={() => {
                    getData(0, { searchElement });
                }}
                resetApi={() =>   getData(0, { searchElement: '' })}
            />

            <>
                <div className='panelTables-container custom-scrollbar' ref={elementRef}>
                    {results?.content?.length > 0
                        ?
                        <div className='row m-0 p-0'>
                            {results?.content?.map((item, index) => {
                                const isDisabled = usersSelected.some(u => (u.userId || u.id)  === item.userId);
                                return (
                                    <div
                                        key={item.id || index}
                                        className={`col-sm-12 col-md-6 m-0 p-0 mb-3 ${index % 2 === 1 ? 'pl-3' : ''} ${isDisabled ? '' : 'cursor-pointer'}`}
                                    >
                                        <UserCardDetails
                                            item={item}
                                            disabled={isDisabled}
                                            setUsersSelected={setUsersSelected}
                                            usersSelected={usersSelected}
                                            setShowCreateNewVisitorModal={setShowCreateNewVisitorModal}
                                            setVisitorSelected={setVisitorSelected}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                        :
                        getChildrenNoInformation(userTypeIds[0])
                    }
                </div>
                <div>
                    {pagination()}
                </div>
            </>

            {showCreateNewVisitorModal &&
                <CreateVisitorModal
                    title={t('add_visitor')}
                    check='true'
                    show={showCreateNewVisitorModal}
                    onHide={() => {
                        setShowCreateNewVisitorModal(false)
                    }}
                    modified={modified}
                    setModified={setModified}
                    setSelectedList={setUsersSelected}
                    selectedList={usersSelected}
                    dataVisitor={visitorSelected}
                    selectVisitorType={true}
                    moduleId={MODELS.Event}
                />
            }
        </>
    );

}
export default AttendingUsersTable
